<div class="bg-primary-50 rounded-3xl">
    <div class="flex justify-center items-center space-x-3 p-1.5">
        <button
            mat-mini-fab
            aria-label="Print application icon"
            class="application-action"
            (click)="handlePrintClick()"
        >
            <mat-icon>print</mat-icon>
        </button>
        @if (!this.isApplicationTemplate()) {
            <button
                mat-mini-fab
                aria-label="Edit note icon"
                title="Add notes to this application"
                class="application-action"
                (click)="handleProceedToNotesClick()"
            >
                <mat-icon>edit_note</mat-icon>
            </button>
            <button
                mat-mini-fab
                aria-label="Attachments icon"
                title="Manage attachments for this application"
                class="application-action"
                [disabled]="isReadOnly()"
                (click)="handleAttachmentsClick()"
            >
                <mat-icon class="rotate-90">attachment</mat-icon>
            </button>
        }
    </div>
</div>
